// extracted by mini-css-extract-plugin
export default {"link":"ch_f8","image":"ch_dx"};